import React from 'react';
import './OrderSummary.css';
import './SecurePayment.css';
import SecurePaymentLogo from '../../../../assets/SecurePaymentLogo.webp';
import Data from '../../../../product_data.json';
const OrderSummary = ({ summary }) => {
  return (
    <div className="order-summary">
      <h3>Order Summary</h3>
      <div className="product-title">
        <b>{Data.SoftwareName} Accounting Software</b>
      </div>
      <ul>
        <li><span>Product Subtotal: </span> <span>₹{summary.subtotal}</span></li>
        <li><span>Feature Pack </span> <span>₹{summary.FeaturePack}</span></li>
        <li><span>Node X {summary.NoOfNode} </span> <span>₹{summary.Node}</span></li>
        <li><span>Coupon Discounts: </span><span>-₹{summary.discount}</span></li>
        <li><span>GST (18%): </span><span>₹{summary.gst}</span></li>
        <li><b><span>Total Amount: </span></b><span><b>₹{summary.total}</b></span></li>
      </ul>
      <div className="coupon-code">
        <input type="text" placeholder="Coupon Code" />
        <button>Apply</button>
      </div>
      <div className="secure-payment">
      <img src={SecurePaymentLogo} alt="Secure Payment Logo" className="secure-payment-logo" />
      <div className="secure-payment-content">
        <h3>Secure Payment</h3>
        <p>Your payments are protected with industry-leading encryption. We prioritize your security, ensuring safe and seamless transactions every time.</p>
      </div>
    </div>
    </div>
  );
};

export default OrderSummary;
